module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "width": "450",
      "title": _vm.$t('personalInformation')
    },
    model: {
      value: (_vm.detailModal),
      callback: function($$v) {
        _vm.detailModal = $$v
      },
      expression: "detailModal"
    }
  }, [_c('div', {
    staticClass: "person-detail",
    staticStyle: {
      "min-height": "500px"
    }
  }, [_c('ul', [(_vm.role == 'merchant') ? _c('li', [_c('p', [_c('label', {
    staticClass: "title-label"
  }, [_vm._v(_vm._s(_vm.$t('merchant.username')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "value-label cb-class"
  }, [_vm._v("\n                        " + _vm._s(_vm.merchant.account) + "\n                    ")])]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "title-label"
  }, [_vm._v(_vm._s(_vm.$t('agent.nickname')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "value-label "
  }, [_vm._v("\n                        " + _vm._s(_vm.merchant.nickname) + "\n                    ")])]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "title-label"
  }, [_vm._v(_vm._s(_vm.$t('agent.balance')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "value-label cb-class"
  }, [_vm._v("\n                        " + _vm._s(_vm.merchant.balance) + "\n                    ")])]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "title-label"
  }, [_vm._v(_vm._s(_vm.$t('merchant.shopName')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "value-label "
  }, [_vm._v("\n                        " + _vm._s(_vm.merchant.shopName) + "\n                    ")])]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "title-label"
  }, [_vm._v(_vm._s(_vm.$t('common.contact')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "value-label "
  }, [_vm._v("\n                        " + _vm._s(_vm.merchant.linkman) + "\n                    ")])]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "title-label"
  }, [_vm._v(_vm._s(_vm.$t('common.phone')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "value-label "
  }, [_vm._v("\n                        " + _vm._s(_vm.merchant.phone) + "\n                    ")])]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "title-label"
  }, [_vm._v(_vm._s(_vm.$t('common.address')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "value-label "
  }, [_vm._v("\n                        " + _vm._s(_vm.merchant.address) + "\n                    ")])])]) : _c('li', [_c('p', [_c('label', {
    staticClass: "title-label"
  }, [_vm._v(_vm._s(_vm.$t('merchant.username')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "value-label cb-class"
  }, [_vm._v("\n                        " + _vm._s(_vm.agent.account) + "\n                    ")])]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "title-label"
  }, [_vm._v(_vm._s(_vm.$t('agent.nickname')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "value-label "
  }, [_vm._v("\n                        " + _vm._s(_vm.agent.remark) + "\n                    ")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowBalance),
      expression: "isShowBalance"
    }]
  }, [_c('label', {
    staticClass: "title-label"
  }, [_vm._v(_vm._s(_vm.$t('agent.platform')) + _vm._s(_vm.$t('agent.balance')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "value-label cb-class"
  }, [_vm._v("\n                        " + _vm._s(_vm.agent.balance) + "\n                    ")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agent.mgw_balance),
      expression: "agent.mgw_balance"
    }]
  }, [_c('label', {
    staticClass: "title-label"
  }, [_vm._v(_vm._s(_vm.$t('agent.mgw_balance')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "value-label cb-class"
  }, [_vm._v("\n                        " + _vm._s(_vm.agent.mgw_balance) + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }), _vm._v(" "), (_vm.list_loadding) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "background": "rgba(210, 216, 222, 0.5)"
    }
  }, [_c('Spin', {
    attrs: {
      "size": "large"
    }
  }), _vm._v(" "), _c('h6', {
    staticStyle: {
      "color": "#2d8cf0",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('loading')))])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed3d1c4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/perDetails.vue
// module id = 482
// module chunks = 103